import { render, staticRenderFns } from "./create-role.vue?vue&type=template&id=5a864c91&"
import script from "./create-role.vue?vue&type=script&lang=ts&"
export * from "./create-role.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-role.vue"
export default component.exports